module.exports = __webpack_public_path__ + "img/newicon8.d1dcac61.svg";